import PropTypes from 'prop-types';
import React from 'react';

// Import images
import dashboardImg from '../../../../../assets/images/Dashboard.png';
import manageAuditorsImg from '../../../../../assets/images/Manage Auditors.png';
import questionnaireImg from '../../../../../assets/images/Questionnaire.png';
import auditImg from '../../../../../assets/images/Audit.png';
import logoutImg from '../../../../../assets/images/Logout.png';
import ibpRefImg from '../../../../../assets/images/IBPReference.png';
import subscriptionImg from '../../../../../assets/images/Managesubscription.png';
import delegateImg from '../../../../../assets/images/ManageDelegate.png';
import supportTicketImg from '../../../../../assets/images/SupportTicket.png';
import helpSupportImg from '../../../../../assets/images/helpSupport.png';
import aibotImg from '../../../../../assets/images/Aibot.png';
import mySectionImg from '../../../../../assets/images/Mysection.png';

const IMAGE_MAP = {
  'Dashboard.png': dashboardImg,
  'Manage Auditors.png': manageAuditorsImg,
  'Questionnaire.png': questionnaireImg,
  'Audit.png': auditImg,
  'Logout.png': logoutImg,
  'IBPReference.png': ibpRefImg,
  'Managesubscription.png': subscriptionImg,
  'ManageDelegate.png': delegateImg,
  'SupportTicket.png': supportTicketImg,
  'helpSupport.png': helpSupportImg,
  'Aibot.png': aibotImg,
  'Mysection.png': mySectionImg
};

const NavIcon = ({ items }) => {
  let navIcons = false;

  if (items.image && IMAGE_MAP[items.image]) {
    navIcons = (
      <span className="pcoded-micon">
        <img
          src={IMAGE_MAP[items.image]}
          alt={items.title}
          style={{ width: '18px', height: '18px', objectFit: 'contain' }}
        />
      </span>
    );
  } else if (items.icon) {
    navIcons = (
      <span className="pcoded-micon">
        <i className={items.icon} />
      </span>
    );
  }

  return <React.Fragment>{navIcons}</React.Fragment>;
};

NavIcon.propTypes = {
  items: PropTypes.object,
  icon: PropTypes.string
};

export default NavIcon;
